import Vue from 'vue';

Vue.component('homepage-mg-news', async () => {
    const component = await import(
        '../async-components/async-homepage-mg-news'
    );
    return component;
});
